import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  isPlatform,
  IonTitle,
  IonContent,
  IonSegment,
  IonSegmentButton,
  IonLabel,
  IonToast,
  IonLoading,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import findProfile from "../../store/profileDetail/actions/findProfile";
import { findProfileUsers } from "../../store/profileDetail/actions/findProfileUsers";
import { resetShowToastStatus } from "../../store/profileDetail/profileDetail.reducer";
import { selectFindStatus } from "../../store/profileDetail/selector/selectFindStatus";
import { selectProfile } from "../../store/profileDetail/selector/selectProfile";
import { selectSegmentProfileSelected } from "../../store/profileDetail/selector/selectSegmentProfileSelected";
import { selectShowToastColor } from "../../store/profileDetail/selector/selectShowToastColor";
import { selectShowToastMessage } from "../../store/profileDetail/selector/selectShowToastMessage";
import { selectShowToastStatus } from "../../store/profileDetail/selector/selectShowToastStatus";
import findUsers from "../../store/users/actions/findUsers";
import { ProfileSegmentGeneral } from "./components/ProfileSegmentGeneral";
import { ProfileSegmentUsers } from "./components/ProfileSegmentUsers";
import { findFormList } from "../../store/profileFormAssigned/actions/findFormList";

export const ProfileDetail: React.FC = () => {
  const { id }: { id: string } = useParams();
  const showToastStatus = useSelector(selectShowToastStatus);
  const showToastMessage = useSelector(selectShowToastMessage);
  const showToastColor = useSelector(selectShowToastColor);
  const dispatch = useDispatch();
  const profile = useSelector(selectProfile);

  const findStatus = useSelector(selectFindStatus);

  useEffect(() => {
    Promise.all([
      dispatch(findProfile(id)),
      dispatch(findProfileUsers(id)),
      dispatch(findUsers()),
      dispatch(findFormList()) // Para listado de plantillas disponibles para asignar al perfil
    ]);
  }, [id, dispatch]);

  const viewSegmentSelectedProfile = useSelector(selectSegmentProfileSelected);
  return (
    <IonPage>
      <IonToast
        isOpen={showToastStatus}
        onDidDismiss={() => dispatch(resetShowToastStatus())}
        message={showToastMessage}
        color={showToastColor}
        duration={2000}
      />
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              text={isPlatform("ios") ? "Perfiles" : ""}
              defaultHref="/app/tic/perfiles"
              color="light"
            />
          </IonButtons>
          <IonTitle>Detalle de perfil {profile.name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        {findStatus === "fulfilled" ? (
          <>
            <section
              className="ion-padding-horizontal ion-padding-top"
              style={{ maxWidth: "800px" }}
            >
              <IonSegment
                onIonChange={(e) => {
                  dispatch({
                    type: "profileDetail/setSelectedSegmentProfile",
                    payload: e.detail.value,
                  });
                }}
                value={viewSegmentSelectedProfile}
                color="primary"
              >
                <IonSegmentButton value="general">
                  <IonLabel>General</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value="usuarios">
                  <IonLabel>Usuarios</IonLabel>
                </IonSegmentButton>
              </IonSegment>
            </section>

            <section
              style={{ maxWidth: "800px" }}
              className={isPlatform("desktop") ? "ion-padding" : ""}
            >
              {viewSegmentSelectedProfile === "general" && <ProfileSegmentGeneral />}
              {viewSegmentSelectedProfile === "usuarios" && <ProfileSegmentUsers />}
            </section>
          </>
        ) : (
          <IonLoading
            cssClass="my-custom-class"
            isOpen={findStatus === "pending"}
            message={"Cargando perfil..."}
          />
        )}
      </IonContent>
    </IonPage>
  );
};
